import MapviewControl from "./MapviewControl";

export default MapviewControl;
